module.exports = __webpack_public_path__ + "img/img-flexibleWelfare.13168291.png";